/**
 * Service Endpoint Configuration
 *
 * This file determines the appropriate service endpoint URL based on the current environment.
 * - Production: jupiter.wealthbee.io
 * - Local development: localhost:5100
 */

/**
 * Get the current Service endpoint URL based on environment and user preference
 */
const getServiceEndpoint = (): string => {
  const isLocalEnvironment = window.location.href.includes("localhost");
  const useLocalApi = localStorage.getItem("useLocalApi");

  // If we're on localhost and the user has explicitly chosen to use production API
  if (isLocalEnvironment && useLocalApi === "false") {
    return "https://jupiter.wealthbee.io/api";
  }
  // If we're on localhost and useLocalApi is unset or true
  else if (
    isLocalEnvironment &&
    (useLocalApi === null || useLocalApi === "true")
  ) {
    return "http://localhost:5100/api";
  }
  // Default to production for all other environments
  else {
    return "https://jupiter.wealthbee.io/api";
  }
};

export default getServiceEndpoint;
